export default function IconHistoryClock({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M13 19.5C17.1421 19.5 20.5 16.1421 20.5 12C20.5 7.85786 17.1421 4.5 13 4.5C8.85786 4.5 5.5 7.85786 5.5 12C5.5 16.1421 8.85786 19.5 13 19.5Z"
        fill="#C2F3FF"
      />
      <path
        d="M13 6.99805V12.4981H18"
        stroke="#191919"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.5 8.99219L3.5 13.4922L7 9.49219"
        stroke="#191919"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 21.5C14.8789 21.5 16.7157 20.9428 18.2779 19.899C19.8402 18.8551 21.0578 17.3714 21.7769 15.6355C22.4959 13.8996 22.684 11.9895 22.3175 10.1466C21.9509 8.30383 21.0461 6.61109 19.7175 5.28249C18.3889 3.95389 16.6962 3.0491 14.8534 2.68254C13.0105 2.31598 11.1004 2.50412 9.36451 3.22315C7.62861 3.94218 6.14491 5.15982 5.10104 6.72209C4.05717 8.28435 3.5 10.1211 3.5 12V13.494"
        stroke="#191919"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
